jQuery(function($) {

    $(document).ready(function() {
        /*
        // Select the original slide items and the list to append cloned slides (for some reason this configuration of Swiper needs more than 3 slides to continuously loop through the 3 visible slides)
        const $sliderList = $('.slider_list');
        const $originalList = $('.slider_list > li');
        const originalSlideCount = $originalList.length;
        const targetCount = 12; // Desired total number of slides

        // // Count current (non-cloned) slides
        const currentSlideCount = $sliderList.find('> li[data-cloned!=true]').length;
        // Calculate how many clones are needed to meet the target
        const neededClones = Math.max(0, Math.ceil((targetCount - currentSlideCount) / originalSlideCount));

        // // Clone and append the necessary number of original slides
        for (let i = 0; i < neededClones; i++) {
            $originalList.each(function () {
                const $clone = $(this).clone();
                $sliderList.append($clone);
            });
        }
        */
        // Initialize Swiper with desired settings
        const swiperOptions = {
            loop: false,
            centeredSlides: true,
            grabCursor: true,
            effect: 'coverflow',
            slidesPerView: 'auto',
            breakpoints: {
                600: {
                    initialSlide: 1,
                }
            },
            coverflowEffect: {
                rotate: 0,
                stretch: -160,
                depth: 200,
                modifier: 1,
                slideShadows: false,
            },
            navigation: {
                nextEl: '.slider_center .swiper-button-next',
                prevEl: '.slider_center .swiper-button-prev',
            },
        };

        // Create Swiper instance
        const swiper = new Swiper('.slider_center .inner', swiperOptions);

    });

});